import getConfig from "next/config"
import Head from "next/head"
import React from "react"

import { HelpBody } from "~/app/Help"
import { Footer } from "~/components/Footer"
import { TrackingProvider } from "~/contexts/Tracking"

type HelpPageProps = {
  configDomain: {
    top: string
    paid: string
    free: string
  }
}

const PAGE_TITLE = "ヘルプ｜イージーゲーム"
const PAGE_DESCRIPTION = "イージーゲームのヘルプ・QA"

const HelpPage: React.FC<HelpPageProps> = ({ configDomain }) => {
  const baseUrl = configDomain.free
  const canonical = `${baseUrl}help/`

  return (
    <TrackingProvider categoryProp="ヘルプ">
      <Head>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={`${baseUrl}assets/img/game_ogp_free.png`} />
        <meta property="og:site_name" content="無料ゲーム" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
      </Head>
      <>
        <HelpBody topUrl={configDomain.free} />
        <Footer hideHelp />
      </>
    </TrackingProvider>
  )
}

export const getStaticProps = async () => {
  const {
    serverRuntimeConfig: { configDomain }
  } = getConfig()

  return { props: { configDomain } }
}

export default HelpPage
